import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import { createLogicMiddleware } from 'redux-logic';
import apiMiddlewares from './apiMiddleware';
import dataGridLogic from '../../data/Grid/logic';
import authLogic from './authLogic';
var logicDeps = {};
export var logicMiddleware = createLogicMiddleware([].concat(_toConsumableArray(dataGridLogic), _toConsumableArray(authLogic)), logicDeps);
var middlewares = [].concat(_toConsumableArray(apiMiddlewares), [logicMiddleware]);
export default middlewares;